var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-dialog-cards",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-dialog-cards-content",
                    },
                    [
                      _c("button", {
                        staticClass:
                          "cw-dialogcards-prev cw-dialogcards-navbutton",
                        class: {
                          "cw-dialogcards-prev-disabled": _vm.hasNoPerv,
                        },
                        attrs: {
                          title: _vm.hasNoPerv
                            ? _vm.$gettext("keine vorherige Karte")
                            : _vm.$gettext("zur vorherigen Karte"),
                        },
                        on: {
                          click: _vm.prevCard,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-dialogcards",
                        },
                        _vm._l(_vm.currentCards, function (card) {
                          return _c(
                            "div",
                            {
                              key: card.index,
                              staticClass: "scene scene--card",
                              class: [card.active ? "active" : ""],
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card",
                                  attrs: {
                                    tabindex: "0",
                                    title: _vm.$gettext("Karte umdrehen"),
                                  },
                                  on: {
                                    click: _vm.flipCard,
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.flipCard.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        )
                                          return null
                                        return _vm.flipCard.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card__face card__face--front",
                                    },
                                    [
                                      card.front_file.length !== 0
                                        ? _c("img", {
                                            attrs: {
                                              src: card.front_file.download_url,
                                            },
                                          })
                                        : _c("div", {
                                            staticClass:
                                              "cw-dialogcards-front-no-image",
                                          }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(card.front_text)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card__face card__face--back",
                                    },
                                    [
                                      card.back_file.length !== 0
                                        ? _c("img", {
                                            attrs: {
                                              src: card.back_file.download_url,
                                            },
                                          })
                                        : _c("div", {
                                            staticClass:
                                              "cw-dialogcards-back-no-image",
                                          }),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(card.back_text))]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("button", {
                        staticClass:
                          "cw-dialogcards-next cw-dialogcards-navbutton",
                        class: {
                          "cw-dialogcards-next-disabled": _vm.hasNoNext,
                        },
                        attrs: {
                          title: _vm.hasNoNext
                            ? _vm.$gettext("keine nächste Karte")
                            : _vm.$gettext("zur nächsten Karte"),
                        },
                        on: {
                          click: _vm.nextCard,
                        },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "button add",
                          on: {
                            click: _vm.addCard,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Karte hinzufügen")))]
                      ),
                      _vm._v(" "),
                      _vm.currentCards.length > 0
                        ? _c(
                            "courseware-tabs",
                            {
                              attrs: {
                                setSelected: _vm.setCardTab,
                              },
                              on: {
                                selectTab: function selectTab($event) {
                                  _vm.activateCard(
                                    parseInt(
                                      $event.name.replace(
                                        _vm.$gettext("Karte") + " ",
                                        ""
                                      )
                                    ) - 1
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.currentCards, function (card, index) {
                              return _c(
                                "courseware-tab",
                                {
                                  key: index,
                                  attrs: {
                                    index: index,
                                    name:
                                      _vm.$gettext("Karte") +
                                      " " +
                                      (index + 1).toString(),
                                    selected: index === 0,
                                    canBeEmpty: "",
                                  },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      staticClass: "default",
                                      on: {
                                        submit: function submit($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext("Bild Vorderseite")
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("studip-file-chooser", {
                                            attrs: {
                                              selectable: "file",
                                              courseId: _vm.context.id,
                                              userId: _vm.userId,
                                              isImage: true,
                                              excludedCourseFolderTypes:
                                                _vm.excludedCourseFolderTypes,
                                            },
                                            on: {
                                              select: function select($event) {
                                                return _vm.updateFile(
                                                  index,
                                                  "front",
                                                  $event
                                                )
                                              },
                                            },
                                            model: {
                                              value: card.front_file_id,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  card,
                                                  "front_file_id",
                                                  $$v
                                                )
                                              },
                                              expression: "card.front_file_id",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext("Text Vorderseite")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: card.front_text,
                                              expression: "card.front_text",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: card.front_text,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                card,
                                                "front_text",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext("Bild Rückseite")
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("studip-file-chooser", {
                                            attrs: {
                                              selectable: "file",
                                              courseId: _vm.context.id,
                                              userId: _vm.userId,
                                              isImage: true,
                                              excludedCourseFolderTypes:
                                                _vm.excludedCourseFolderTypes,
                                            },
                                            on: {
                                              select: function select($event) {
                                                return _vm.updateFile(
                                                  index,
                                                  "back",
                                                  $event
                                                )
                                              },
                                            },
                                            model: {
                                              value: card.back_file_id,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  card,
                                                  "back_file_id",
                                                  $$v
                                                )
                                              },
                                              expression: "card.back_file_id",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext("Text Rückseite")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: card.back_text,
                                              expression: "card.back_text",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: card.back_text,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                card,
                                                "back_text",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      !_vm.onlyCard
                                        ? _c("label", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "button trash",
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.removeCard(index)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$gettext(
                                                        "Karte entfernen"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Lernkarten-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }